import { configureStore } from "@reduxjs/toolkit";
import TabSlice from "./TabSlice";
import LanguageSlice from "./LanguageSlice";
import DistrictSlice from "./DistrictSlice";
import ProvinceSlice from "./ProvinceSlice";
import OrganizationSlice from "./OrganizationSlice";
import OffenceSlice from "./OffenceSlice";
import AppContentSlice from "./AppContentSlice";
import PageSlice from "./PageSlice";
import InitialDataSlice from "./InitialDataSlice";

const store = configureStore({
  reducer: {
    tab: TabSlice,
    language: LanguageSlice,
    district: DistrictSlice,
    province: ProvinceSlice,
    organizations: OrganizationSlice,
    offence: OffenceSlice,
    appContent: AppContentSlice,
    page: PageSlice,
    initialData: InitialDataSlice,
  },
});

export default store;
